import React from 'react';
import ChartistGraph from 'react-chartist';
import {chart1 ,chart2, chart2Data,chart9Data,chart11Data, chart7Data,chart7Options, chart2Option ,chart3Data,chart3Options,chart6Data,chart6Options ,chart4Data ,chart4Options ,chart5Data ,chart5Options, chart10Data, chart10Options, chart11Options, chart12Data, chart12Options} from './ChartistData';
import {Row,Col,Card} from "react-bootstrap";

const Chartist = (props) => {
    return (
        <React.Fragment>
            <Row>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Advanced SMIL Animations</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                        key="1" 
                        className="ct-6 flot-chart-container" 
                        data={{
                            labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
                            series: [[12, 9, 7, 8, 5, 4, 6, 2, 3, 3, 4, 6],
                            [4, 5, 3, 7, 3, 5, 5, 3, 4, 4, 5, 5],
                            [5, 3, 4, 5, 6, 3, 3, 4, 5, 6, 3, 4],
                            [3, 4, 5, 6, 7, 6, 4, 5, 6, 7, 6, 3]]
                        }} type={'Line'} listener={{
                            "draw": function (data) {
                                if (data.type === 'line' || data.type === 'area') {
                                    data.element.animate({
                                        d: {
                                            begin: 2000 * data.index,
                                            dur: 2000,
                                            from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                                            to: data.path.clone().stringify(),
                                        }
                                    });
                                }
                            }
                        }} options={chart1}  />
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>SVG Path animation</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                        key="1" 
                        className="ct-7 flot-chart-container" 
                        data={{
                            labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                            series: [ [1, 5, 2, 5, 4, 3],
                            [2, 3, 4, 8, 1, 2],
                            [5, 4, 3, 2, 1, 0.5]]
                        }} type={'Line'} listener={{
                            "draw": function (data) {
                                if (data.type === 'line' || data.type === 'area') {
                                    data.element.animate({
                                        d: {
                                            begin: 2000 * data.index,
                                            dur: 2000,
                                            from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                                            to: data.path.clone().stringify(),
                                        }
                                    });
                                }
                            }
                        }} options={chart2} />
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Animating a Donut with Svg.animate</h5>
                  </Card.Header>
                  <Card.Body>
                        <ChartistGraph 
                            data={chart2Data} 
                            options={chart2Option} 
                            type={'Pie'} 
                            className="fct-8 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Bi-polar Line chart with area only</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                                data={chart3Data} 
                                options={chart3Options} 
                                type={'Line'} 
                                className="ct-5 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Line chart with area</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                                data={chart4Data} 
                                options={chart4Options} 
                                type={'Line'} 
                                className="ct-4 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Bi-polar bar chart</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                                data={chart5Data} 
                                options={chart5Options} 
                                type={'Bar'} 
                                className="ct-9 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Stacked bar chart</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                                data={chart6Data} 
                                options={chart6Options} 
                                type={'Bar'} 
                                className="ct-10 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Horizontal bar chart</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                                data={chart7Data} 
                                options={chart7Options} 
                                type={'Bar'} 
                                className="ct-11 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Extreme responsive configuration</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                                data={chart9Data.data} 
                                options={chart9Data.options} 
                                responsiveOptions={chart9Data.responsiveOptions} 
                                type={'Bar'} 
                                className="ct-12 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Simple line chart</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                                data={chart10Data} 
                                options={chart10Options} 
                                type={'Line'} 
                                className="ct-1 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Holes in data</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                            data={chart11Data} 
                            options={chart11Options} 
                            type={'Line'} 
                            className="ct-2 flot-chart-container"/>              
                  </Card.Body>
                </Card>
              </Col>
              <Col xl="6" md="12" sm="12">
                <Card>
                  <Card.Header>
                    <h5>Filled holes in data</h5>
                  </Card.Header>
                  <Card.Body>
                    <ChartistGraph 
                            data={chart12Data} 
                            options={chart12Options} 
                            type={'Line'} 
                            className="ct-3 flot-chart-container"/>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </React.Fragment>
    );
}

export default Chartist;